import { useT } from "../i18n/index.js";

export function PageLoading() {
  const t = useT("common");
  return (
    <p role="status" className="p-6 text-sm text-muted-foreground">
      {t("loading")}
    </p>
  );
}
